<div class="relative z-1 dark:bg-gray-900 sm:p-0">
    <router-outlet></router-outlet>
</div>
